import React, {useState} from 'react'
import styles from "./Accordion.module.scss";
import { ChevronRight } from 'react-feather';

export default function Accordion(props) {
    

    return (
        <>
            <div className={styles.container}>
                <div className={styles.header}>
                    {props.icon}<h2>{props.title}</h2>
                </div>
                <div className={styles.contentContainer}>
                    {props.data.map((section, i) =>
                        <a key={i} className={styles.accordionContainer} href={section.link} target="_blank" rel="noopener">
                            <div className={styles.accordionSection} >  
                                <span>{section.header}</span>
                                 <ChevronRight size={20} color="var(--adfi_blue500)"/>
                            </div>
                        </a> 
                    )}
                </div>
            </div>
        </>
    )
}
